<template>
	<section class="container" v-if="products">

		<header class="container__header">

			<h1>Opret bestilling</h1>

		</header>

		<section class="container__body container__body--md">

            <section class="col-12 margin-b-75">

                <router-link :to="{name:'make-order-choice'}">Tilbage</router-link>

            </section>

			<header class="col-12 flex--space padding-b-25 border-b">

				<h1>Oversigt</h1>

				<!-- <section class="select-sm">

					<ws-select :options="choices" v-model="chosenOption"></ws-select>

				</section> -->

			</header>

			<section class="data-list">

				<transition-group name="fade" tag="section">

					<section class="item" v-for="product in productsFiltered" :key="product.id">

						<section class="icon">

							<i class="icon--lg fas fa-book"></i>

						</section>

						<section class="content">

							<h1 v-text="product.title"></h1>

							<ul>

								<li v-if="product.active">Status: Aktiv</li>
								<li v-else>Status: Inaktiv</li>
								<li>Kategori: {{product.category_title}}</li>
								<li>Pris: {{stripeAmount(product.price).amount}},-</li>

							</ul>

						</section>

						<section class="link">

							<router-link :to="{name:'make-order.manage', params:{type:'Product', id:product.id}}">Vælg</router-link>

						</section>

					</section>

				</transition-group>

			</section>

		</section>

	</section>
</template>

<script>
	import {mapGetters} from 'vuex';
    export default {
        name: "index",
		data(){
            return {
                chosenOption:0,
                choices:[
                    'Aktive produkter',
                    'Inaktive produkter',
                ]
			};
		},
		computed:{
			...mapGetters({
				products:'products'
			}),
            active(){
                return (this.chosenOption === 0) ? true:false;
            },
			productsFiltered(){
			    return this.products.filter(item=>{
			        return item.active == this.active;
				})
			}
		},
		created(){
			this.$store.dispatch('getProducts');
		}
    }
</script>
